import React from 'react';
import { LoadingSpinnerSVG } from 'AppSrc/core/components/common/svg-icons';
import 'AppSrc/core/style/components/utility/loading-spinner.css';

const LoadingSpinner = () => (
  <div className="loading-spinner">
    <LoadingSpinnerSVG />
  </div>
);

export { LoadingSpinner };
